import React, { useEffect, useState } from "react";
import { fetchData } from "../api";
import Card from "../components/Card";
import { postData } from "../api";
import Chart from "../components/Chart";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const getCurrentDate = () => {
    const date = new Date();
    return date.toISOString().split("T")[0]; // Format to YYYY-MM-DD
  };

  const [reportData, setReportData] = useState([]);
  const [dateFrom, setDateFrom] = useState(getCurrentDate());
  const [dateTo, setDateTo] = useState(getCurrentDate());
  const [chartData, setChartData] = useState(null);
  const [repairsTotal, setRepairsTotal] = useState(0);
  const [data, setData] = useState({
    totalOrders: 0,
    activeUsers: 0,
    todayRevenue: 0,
  });
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const fetchDashboardData = async () => {
      const orders = await fetchData("histories");
      const users = await fetchData("users");
      setData({
        totalOrders: orders.length,
        activeUsers: users.filter((user) => user.isActive).length,
        todayRevenue: orders.reduce(
          (sum, order) => sum + parseFloat(order.totalPrice),
          0
        ),
      });
    };
    fetchDashboardData();
  }, []);

  const fetchReport = async () => {
    const date = {
      date_from: dateFrom,
      date_to: dateTo,
    };

    try {
      const data = await postData("report", date);
      setReportData(data.products);
      setRepairsTotal(data.repairs_total);

      // Process chart data
      const chartLabels = data.products.map((item) => item.product__itemName);
      const chartValues = data.products.map((item) => item.total_sold);

      setChartData({
        labels: chartLabels,
        datasets: [
          {
            label: "Борлуулалт",
            data: chartValues,
            backgroundColor: "rgba(75, 192, 192, 0.6)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 1,
          },
        ],
      });
    } catch (error) {
      console.error("Алдаа гарлаа:", error.message);
      alert("Тайлан татаж чадсангүй. Дахин оролдоно уу.");
    }
  };

  const user = JSON.parse(sessionStorage.getItem("user"));
  const navigate = useNavigate();
  const onLogout = () => {
    sessionStorage.removeItem("user");
    window.location.reload();
  };

  return (
    <div className="min-h-screen p-4 md:p-6 bg-gray-50 overflow-auto lg:p-6 mt-10 lg:mt-0">
      {/* Mobile Header */}
      <div className="md:hidden flex justify-between items-center mb-4">
        {/* <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="p-2 rounded-md text-gray-700 hover:bg-gray-200"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button> */}
        <h1 className="text-xl font-bold text-gray-800">Удирдах самбар</h1>
        <div className="w-6"></div> {/* Spacer for alignment */}
      </div>

      {/* Mobile Menu */}
      <div className="md:hidden bg-white rounded-lg shadow-lg p-4 mb-4">
        <div className="flex items-center justify-between mb-4">
          <span className="font-medium">Тавтай морил, {user.username}!</span>
          <button
            onClick={onLogout}
            className="bg-red-500 hover:bg-red-600 text-white text-sm font-bold py-1 px-3 rounded"
          >
            Гарах
          </button>
        </div>
      </div>

      {/* Desktop Header */}
      <div className="hidden md:flex items-center justify-between mb-6">
        <h1 className="text-3xl font-bold text-gray-800">Удирдах самбар</h1>
        <div className="flex items-center space-x-4">
          <span className="text-gray-700">Тавтай морил, {user.username}!</span>
          <button
            onClick={onLogout}
            className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded"
          >
            Гарах
          </button>
        </div>
      </div>

      {/* Картууд */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <Card
          title="Нийт дуудлага"
          value={data.totalOrders}
          bgColor="bg-blue-100"
          textColor="text-blue-800"
          compact={true}
        />
        <Card
          title="Идэвхтэй хэрэглэгчид"
          value={data.activeUsers}
          bgColor="bg-green-100"
          textColor="text-green-800"
          compact={true}
        />
        <Card
          title="Нийт Дүн"
          value={`${parseFloat(data.todayRevenue).toLocaleString()}₮`}
          bgColor="bg-yellow-100"
          textColor="text-yellow-800"
          compact={true}
        />
      </div>

      {/* Тайлан хэсэг */}
      <div className="bg-white p-4 md:p-6 rounded-lg shadow-md">
        <h1 className="text-xl md:text-2xl font-bold mb-4 text-gray-800">
          Тайлан
        </h1>

        {/* Огнооны сонголт */}
        <div className="mb-6 flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Эхлэх огноо:
            </label>
            <input
              type="date"
              className="w-full border p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Дуусах огноо:
            </label>
            <input
              type="date"
              className="w-full border p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </div>
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 sm:mt-6"
            onClick={fetchReport}
          >
            Тайлан харах
          </button>
        </div>

        {/* График */}
        {chartData && (
          <div className="mb-8">
            <h2 className="text-xl font-bold mb-4 text-gray-800">
              Барааны борлуулалтын график
            </h2>
            <Chart data={chartData} title="Барааны борлуулалтын статистик" />
          </div>
        )}

        {/* Засварын нийт үнийн дүн */}
        {repairsTotal > 0 && (
          <div className="mb-6 p-4 bg-gray-50 rounded-lg">
            <h2 className="text-lg md:text-xl font-bold mb-2 text-gray-800">
              Засварын нийт үнийн дүн
            </h2>
            <p className="text-gray-700 text-lg font-semibold">
              {parseFloat(repairsTotal).toLocaleString()}₮
            </p>
          </div>
        )}

        {/* Барааны борлуулалтын хүснэгт */}
        {reportData.length > 0 && (
          <div className="overflow-x-auto">
            <h2 className="text-lg md:text-xl font-bold mb-3 text-gray-800">
              Барааны борлуулалт
            </h2>
            <div className="shadow rounded-lg overflow-hidden">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Барааны нэр
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Тоо хэмжээ
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {[...reportData]
                    .sort((a, b) => b.total_sold - a.total_sold)
                    .map((report, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">
                          {report.product__itemName}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">
                          {report.total_sold}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
